import { callServiceMachine } from './callService';
import { genericMachine } from './genericMachine';
import { coreServiceResponseFactory } from './serviceResponseFactory';
import { accumulateVersions } from './version';
import { getReturnResponseDefault } from './getReturnResponseDefault';
import { handleCodeErrorsResponse } from './codeErrorsResponse';

export { default as Bundle } from './bundle';
export { default as Mocks } from './Mocks';
export { default as obfuscateJson } from './obfuscateJson';

export { STATUS_SERVICE_SUCCESS, HeadersType } from './constants';
import { STATUS_SERVICE_SUCCESS, HeadersType } from './constants';

export { prepareGenericData } from './prepareDataMachine';
export default {
  genericMachine,
  callServiceMachine,
  accumulateVersions,
  getReturnResponseDefault,
  coreServiceResponseFactory,
  handleCodeErrorsResponse,
  constants: {
    STATUS_SERVICE_SUCCESS,
    HeadersType,
  },
};
